import { render, staticRenderFns } from "./DelayedOrdersTable.vue?vue&type=template&id=83a32d02&scoped=true"
import script from "./DelayedOrdersTable.vue?vue&type=script&lang=js"
export * from "./DelayedOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./DelayedOrdersTable.vue?vue&type=style&index=0&id=83a32d02&prod&lang=css"
import style1 from "./DelayedOrdersTable.vue?vue&type=style&index=1&id=83a32d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a32d02",
  null
  
)

export default component.exports